// Resend-OTP cooldown that survives a page refresh.
//
// The OTP screens kept the countdown in component state only, so remounting the page
// (refresh, or navigating away and back) restarted it from the full duration while the
// server's cooldown kept running from the moment the OTP was actually sent. The two then
// disagreed: the button could re-enable while the server still answered 429, or the user
// was made to wait again from scratch.
//
// Storing when the OTP was sent lets the countdown be derived instead of counted, so the
// UI and the server both measure from the same event.

const KEY_PREFIX = "otpSentAt_";

/** Record that an OTP was just sent for this flow. */
export const markOtpSent = (flow) => {
  try {
    // OLD: localStorage.setItem(KEY_PREFIX + flow, String(Date.now()));
    sessionStorage.setItem(KEY_PREFIX + flow, String(Date.now()));
  } catch (e) {
    // Private mode / blocked storage - the countdown just falls back to a full wait.
    console.warn("[otp-cooldown] could not record send time for", flow, e);
  }
};

/**
 * Seconds still to wait for this flow.
 * Returns the full cooldown when nothing is stored, so an unknown state waits rather
 * than letting the user straight through to a 429.
 */
export const getRemainingCooldown = (flow, cooldownSeconds) => {
  try {
    // OLD: const raw = localStorage.getItem(KEY_PREFIX + flow);
    const raw = sessionStorage.getItem(KEY_PREFIX + flow);
    if (!raw) return cooldownSeconds;
    const sentAt = parseInt(raw, 10);
    if (!sentAt || Number.isNaN(sentAt)) return cooldownSeconds;
    const remaining = cooldownSeconds - Math.floor((Date.now() - sentAt) / 1000);
    if (remaining <= 0) return 0;
    // Guard against a clock change making the stored stamp look like the future.
    return Math.min(remaining, cooldownSeconds);
  } catch (e) {
    console.warn("[otp-cooldown] could not read send time for", flow, e);
    return cooldownSeconds;
  }
};

/** Clear the stamp once the flow is finished, so a later visit starts clean. */
export const clearOtpSent = (flow) => {
  try {
    // OLD: localStorage.removeItem(KEY_PREFIX + flow);
    sessionStorage.removeItem(KEY_PREFIX + flow);
  } catch (e) {
    // nothing to do
  }
};

/**
 * Pull the wait out of the server's throttle message
 * ("Please wait 42 seconds before requesting another code.") so a UI that has drifted
 * can resynchronise. Returns 0 when there is no number to read.
 */
export const parseWaitSeconds = (message) => {
  const match = /(\d+)\s*second/i.exec(message || "");
  return match ? parseInt(match[1], 10) : 0;
};

export const OTP_FLOW = {
  FORGOT_PASSWORD: "forgotPassword",
  TWO_FA: "twoFa",
};
